<template>
  <div class="record-list">
    <EmptyBox class="list-empty" v-if="isEmpty"></EmptyBox>
    <InfiniteBox @reachBottom="handleReachBottom" v-if="!isEmpty">
      <ul class="list" v-if="kind === ListKind.Store">
        <li v-for="item in data" class="item">
          <div class="left">
            <div class="title">{{ item.taskTitle }}</div>
            <div class="date">{{ date(item.createTime) }}</div>
          </div>
          <div class="right count">+{{ item.count }}</div>
        </li>
      </ul>
      <ul class="list" v-if="kind === ListKind.Exchange">
        <li v-for="item in data" class="item">
          <div class="left">
            <div class="title">
              {{ item.exchPrizeName }}
              {{ item.exchPrizeCount > 1 ? `x${item.exchPrizeCount}` : ''}}
            </div>
            <div class="date">{{ date(item.createTime) }}</div>
          </div>
          <div class="right count">-{{ item.count }}</div>
        </li>
      </ul>
    </InfiniteBox>
  </div>
</template>

<script>
import { defineComponent, watch, computed } from '@vue/composition-api';
import EmptyBox from '../empty-box/index.vue';
import { useRecordList, ListKind } from '../../store/record-list';
import { showToast, IconType, hideToast } from '@tencent/wphk-act-base-ui';
import { storeToRefs } from 'pinia';
import InfiniteBox from '../infinite-box/index.vue';
import dayjs from 'dayjs';
import { i18n } from '../../i18n';

export default defineComponent({
  components: {
    EmptyBox,
    InfiniteBox,
  },
  setup() {
    const recordListStore = useRecordList();
    const { data, kind, isLoading } = storeToRefs(recordListStore);
    const { loadMore } = recordListStore;

    const date = (time) => dayjs(time).format('YYYY-MM-DD');
    const isEmpty = computed(() => !data.value.length);

    watch(isLoading, () => {
      if (isLoading.value) {
        showToast({
          icon: IconType.loading,
          duration: 0,
          title: i18n('数据加载中...'),
        });
      } else {
        hideToast();
      }
    });

    const handleReachBottom = () => {
      if (!isLoading.value) {
        loadMore();
      }
    };

    return { data, isEmpty, kind, ListKind, date, handleReachBottom };
  },
});
</script>

<style scoped lang="less">
@rem: 200rem;

.record-list, .list-empty {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.list {
  margin: 0;
  padding: 0;
  margin-top: 26/@rem;
  list-style: none;
  padding-bottom: 80/@rem;
}
.item {
  padding: 24/@rem 0;
  display: flex;
  align-items: center;
  border-top: solid 1px rgba(230, 230, 230, 1);
}
.left {
  flex: 1;
  overflow: hidden;
}
.title {
  font-size: 24/@rem;
  line-height: 32/@rem;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 60/@rem;
}
.date {
  font-size: 24/@rem;
  line-height: 32/@rem;
  color: rgba(128, 128, 128, 1);
}
.count {
  font-size: 28/@rem;
  font-weight: 400;
  line-height: 40/@rem;
}
</style>
